import React, { FC } from 'react';
import { DatePicker as AntdDatePicker } from 'antd';
import { DatePickerProps } from 'antd/lib/date-picker';

export const DatePicker: FC<DatePickerProps> = (props) => {
  return <AntdDatePicker {...props} />;
};

export default DatePicker;
